export default "__VITE_ASSET__B2$tQDFf__ 320w, __VITE_ASSET__RwOEeQ3d__ 640w";